import { ConsultationTreatmentTypes } from '@enums/consultation-treatment-types';
import { Gender } from '@enums/gender';
import { Pharmacy } from '@enums/pharmacies';
import { TreatmentGenderSettings } from '@models/treatment-types/treatment-gender-settings.model';
import { TreatmentType } from '@models/treatment-types/treatment-type.model';

/**
 * Defines the Peptide GS Renewal treatment type.
 */
export const PeptideGsRenewalTreatmentType = new TreatmentType({
  id: '29',
  name: ConsultationTreatmentTypes.PeptideGsRenewal,
  designatedPharmacyId: Pharmacy.CASA_PHARMA,
  genderSettings: new TreatmentGenderSettings({
    excludedForUpsells: {
      '/consultation/testosterone-therapy': Gender.Female,
      '/consultation/sexual-performance': Gender.Female,
    },
  }),
  requireHeightAndWeight: true,
});
